import { ErrorBoundary } from '../ErrorBoundry.tsx';
import { TrialAppRoutes } from './TrialAppRoutes.tsx';
import { NavigationLayout } from '../components/Navigation/Layout.tsx';

export function TrialAppContent() {
  return (
    <NavigationLayout sidebar={null}>
      <ErrorBoundary>
        <TrialAppRoutes />
      </ErrorBoundary>
    </NavigationLayout>
  );
}
